import { render } from "./ClipboardComponent.vue?vue&type=template&id=23f78f9a&ts=true"
import script from "./ClipboardComponent.vue?vue&type=script&lang=ts"
export * from "./ClipboardComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3101032983/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__